<div class="menu">
    <span class="menu-heading">{{ Heading }}</span>
    <span class="close" (click)="closeTaskSelectionMenu()">X</span>
  </div>
  <div class="container m-0 p-0" *ngIf="notesArray && notesArray.length > 0; else elsePart">
    <div class="notes-list">
      <div class="note-item" *ngFor="let note of notesArray" [class.expanded]="note.isExpanded">
        <div class="note-header" (click)="toggleNote(note)">
          <span class="expand-icon">
            <svg width="12" height="12" viewBox="0 0 12 12" [class.rotated]="note.isExpanded">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="note-user">{{ note.userName }}</span>
          <span class="note-datetime">
            <span class="note-date">{{ note.date }}</span>
            <span class="note-time">{{ note.time }}</span>
          </span>
        </div>
        <div class="note-content" *ngIf="note.isExpanded" [innerHtml]="note.content"></div>
      </div>
    </div>
  </div>
  <ng-template #elsePart>
    <div class="fs-5 fw-bold container">There is no notes history for this case.</div>
  </ng-template>
  